/* Fairybell PDP test (v1 / v2) — option picker, flagpole add-on, live total, sticky bar */
(function () {
  if (window.__fbPdpInit) return;
  window.__fbPdpInit = true;

  var FLAG = '<svg class="fb-flag" viewBox="0 0 16 16" width="13" height="13" aria-hidden="true"><path d="M3.5 15V1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M4 2h9l-2 3 2 3H4z" fill="currentColor"/></svg>';
  function num(v) { var m = String(v || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
  function fmtLeds(l) { return num(l).toLocaleString('en-US'); }
  function money(cents, cur) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function isPreorder(p) { return p.available && p.policy === 'continue' && p.inv <= 0 && p.tracked === 'shopify'; }
  function inStock(p) { return p.available && (p.inv > 0 || p.tracked !== 'shopify'); }
  function score(p) { return (inStock(p) ? 3 : isPreorder(p) ? 2 : p.available ? 1 : 0); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function withView(url) {
    var params = new URLSearchParams(window.location.search);
    var keep = new URLSearchParams();
    ['view', 'preview_theme_id'].forEach(function (k) { if (params.get(k)) keep.set(k, params.get(k)); });
    var q = keep.toString();
    return q ? url + (url.indexOf('?') > -1 ? '&' : '?') + q : url;
  }
  function colorDot(c) {
    var k = String(c).toLowerCase();
    if (k.indexOf('multi') > -1 || k.indexOf('smart') > -1) return 'conic-gradient(#e53b3b,#f2c230,#3bb36b,#3b7be5,#e53b3b)';
    if (k.indexOf('switch') > -1) return 'linear-gradient(90deg,#f3c25e 50%,#3b7be5 50%)';
    if (k.indexOf('twinkle') > -1) return 'radial-gradient(circle,#fff6d8 0 30%,#f3c25e 31%)';
    if (k.indexOf('red') > -1 && k.indexOf('white') > -1) return 'linear-gradient(90deg,#f3c25e 50%,#d8312f 50%)';
    if (k.indexOf('red') > -1) return '#d8312f';
    if (k.indexOf('green') > -1) return '#2f9a4a';
    if (k.indexOf('blue') > -1) return '#2f6fd8';
    return '#f3c25e';
  }

  function Picker(root) {
    this.root = root;
    this.style = root.dataset.style || 'v1';
    var dataEl = root.querySelector('[data-fb-data]');
    this.data = JSON.parse(dataEl.textContent);
    this.cur = this.data.currency;
    var all = this.data.products.filter(function (p) { return p.h && p.c && p.l; });
    var currentId = this.data.currentId;
    this.current = all.filter(function (p) { return p.id === currentId; })[0];
    if (!this.current) { root.hidden = true; return; }
    // dedupe identical height/color/LED combos: keep current, else best availability
    var cells = {};
    all.forEach(function (p) {
      var k = num(p.h) + '|' + p.c.toLowerCase() + '|' + num(p.l);
      var ex = cells[k];
      if (!ex) { cells[k] = p; return; }
      if (ex.id === currentId) return;
      if (p.id === currentId || score(p) > score(ex)) cells[k] = p;
    });
    var cur = this.current;
    this.items = Object.keys(cells).map(function (k) { return cells[k]; })
      .filter(function (p) { return p.available || p.id === cur.id; });
    this.render();
  }

  Picker.prototype.isPole = function (p) { return num(p.h) <= 13; };
  Picker.prototype.colorsOrder = ['warm white', 'twinkle', 'multicolor'];

  Picker.prototype.best = function (cands, prefer) {
    var self = this;
    cands = cands.slice().sort(function (a, b) {
      var pa = prefer(a), pb = prefer(b);
      if (pa !== pb) return pb - pa;
      var sa = score(a), sb = score(b);
      if (sa !== sb) return sb - sa;
      return Math.abs(num(a.l) - num(self.current.l)) - Math.abs(num(b.l) - num(self.current.l));
    });
    return cands[0];
  };

  Picker.prototype.targetFor = function (dim, value) {
    var c = this.current, self = this;
    var sameColor = function (p) { return p.c.toLowerCase() === c.c.toLowerCase() ? 1 : 0; };
    if (dim === 'mode') {
      var wantPole = value === 'pole';
      var cands = this.items.filter(function (p) { return self.isPole(p) === wantPole; });
      if (!cands.length) return null;
      // nearest height to the boundary (13ft for pole, 20ft for flagpole), same colour if possible
      var target = wantPole ? 13 : 20;
      return cands.sort(function (a, b) {
        var d = Math.abs(num(a.h) - target) - Math.abs(num(b.h) - target);
        if (d) return d;
        var s = sameColor(b) - sameColor(a); if (s) return s;
        return score(b) - score(a);
      })[0];
    }
    if (dim === 'h') return this.best(this.items.filter(function (p) { return num(p.h) === value; }), sameColor);
    if (dim === 'c') return this.best(this.items.filter(function (p) { return num(p.h) === num(c.h) && p.c.toLowerCase() === value; }), function () { return 0; });
    if (dim === 'l') return this.items.filter(function (p) { return num(p.h) === num(c.h) && p.c.toLowerCase() === c.c.toLowerCase() && num(p.l) === value; })[0];
    return null;
  };

  Picker.prototype.render = function () {
    var self = this, c = this.current, v2 = this.style === 'v2';
    var pole = this.isPole(c);
    var modeItems = this.items.filter(function (p) { return self.isPole(p) === pole; });
    var heights = Array.from(new Set(modeItems.map(function (p) { return num(p.h); }))).sort(function (a, b) { return a - b; });
    var atH = this.items.filter(function (p) { return num(p.h) === num(c.h); });
    var colors = Array.from(new Set(atH.map(function (p) { return p.c.toLowerCase(); })));
    colors.sort(function (a, b) {
      var ia = self.colorsOrder.indexOf(a), ib = self.colorsOrder.indexOf(b);
      return (ia < 0 ? 9 : ia) - (ib < 0 ? 9 : ib);
    });
    var atHC = atH.filter(function (p) { return p.c.toLowerCase() === c.c.toLowerCase(); })
      .sort(function (a, b) { return num(a.l) - num(b.l); });
    var hasPole = this.items.some(function (p) { return self.isPole(p); });
    var hasFlag = this.items.some(function (p) { return !self.isPole(p); });
    var range = function (list) {
      var hs = list.map(function (p) { return num(p.h); });
      var lo = Math.min.apply(null, hs), hi = Math.max.apply(null, hs);
      return (lo === hi ? lo : lo + '–' + hi) + 'ft';
    };
    var html = '';
    var uid = 'fb' + Math.random().toString(36).slice(2, 7);

    // Step: where / mode
    if (hasPole && hasFlag) {
      var poleItems = this.items.filter(function (p) { return self.isPole(p); });
      var flagItems = this.items.filter(function (p) { return !self.isPole(p); });
      if (v2) {
        html += '<div class="fb-step"><div class="fb-label">Size</div><div class="fb-tabs" role="tablist">' +
          '<a role="tab" class="fb-tab' + (!pole ? ' is-on' : '') + '" data-dim="mode" data-val="flag" href="#">Flagpole tree · ' + range(flagItems) + '</a>' +
          '<a role="tab" class="fb-tab' + (pole ? ' is-on' : '') + '" data-dim="mode" data-val="pole" href="#">With pole · ' + range(poleItems) + '</a></div>';
      } else {
        html += '<div class="fb-step"><div class="fb-label">Which type?</div><div class="fb-seg">' +
          '<a class="fb-seg__opt' + (!pole ? ' is-on' : '') + '" data-dim="mode" data-val="flag" href="#"><b>Flagpole tree</b><span>' + range(flagItems) + (self.root.dataset.poleHeights ? ' · flagpole available' : ' · on a flagpole') + '</span></a>' +
          '<a class="fb-seg__opt' + (pole ? ' is-on' : '') + '" data-dim="mode" data-val="pole" href="#"><b>Tree with pole</b><span>' + range(poleItems) + ' · pole included</span></a></div></div>';
      }
    } else if (v2) {
      html += '<div class="fb-step"><div class="fb-label">Size</div>';
    }

    // Step: height
    if (v2) {
      var maxH = Math.max.apply(null, heights);
      html += '<div class="fb-trees">' + heights.map(function (h) {
        var px = Math.round(26 + 40 * (h / maxH));
        var w = Math.round(px * 0.62);
        var tree = '<svg width="' + w + '" height="' + px + '" viewBox="0 0 ' + w + ' ' + px + '" aria-hidden="true"><polygon points="' + (w / 2) + ',2 ' + (w - 2) + ',' + (px - 2) + ' 2,' + (px - 2) + '" fill="#f3c25e"/><line x1="' + (w / 2) + '" y1="0" x2="' + (w / 2) + '" y2="' + px + '" stroke="#7a8496" stroke-width="1.5"/></svg>';
        var match = (!pole && (h === 20 || h === 26) && self.root.dataset.poleHeights && self.root.dataset.poleHeights.split(',').indexOf(String(h)) > -1) ? '<small>pole match</small>' : '<small>&nbsp;</small>';
        return '<a class="fb-tree' + (h === num(c.h) ? ' is-on' : '') + '" data-dim="h" data-val="' + h + '" href="#">' + tree + '<span>' + h + 'ft</span>' + match + '</a>';
      }).join('') + '</div></div>';
    } else {
      html += '<fieldset class="fb-step product-form__input product-form__input--pill"><legend class="form__label">Height' + (pole ? '' : ' <span class="fb-hint">· match your flagpole' + (self.root.dataset.poleHeights ? ' · ' + FLAG + ' = we also sell the flagpole' : '') + '</span>') + '</legend>' +
        heights.map(function (h, i) {
          var id = uid + 'h' + i;
          var hasPoleH = !pole && (self.root.dataset.poleHeights || '').split(',').indexOf(String(h)) > -1;
          return '<input type="radio" id="' + id + '" name="' + uid + 'h" data-dim="h" data-val="' + h + '"' + (h === num(c.h) ? ' checked' : '') + '><label for="' + id + '"' + (hasPoleH ? ' title="Matching flagpole available"' : '') + '>' + h + 'ft' + (hasPoleH ? FLAG : '') + '</label>';
        }).join('') + '</fieldset>';
    }

    // Step: colour
    if (colors.length > 1 || v2) {
      var colorLabel = function (key) {
        var p = self.targetFor('c', key);
        return { p: p, name: p ? p.c : key };
      };
      if (v2) {
        html += '<div class="fb-step"><div class="fb-label">Light <span>' + esc(c.c) + '</span></div><div class="fb-swatches">' +
          colors.map(function (k) {
            var o = colorLabel(k);
            return '<a class="fb-sw' + (k === c.c.toLowerCase() ? ' is-on' : '') + '" data-dim="c" data-val="' + esc(k) + '" href="#"><span class="fb-sw__dot" style="background:' + colorDot(k) + '"></span>' + esc(o.name) +
              (o.p && isPreorder(o.p) ? '<em class="fb-pre">Pre-order</em>' : '') + '</a>';
          }).join('') + '</div></div>';
      } else {
        html += '<fieldset class="fb-step product-form__input product-form__input--pill"><legend class="form__label">LED color</legend>' +
          colors.map(function (k, i) {
            var o = colorLabel(k), id = uid + 'c' + i;
            return '<input type="radio" id="' + id + '" name="' + uid + 'c" data-dim="c" data-val="' + esc(k) + '"' + (k === c.c.toLowerCase() ? ' checked' : '') + '><label for="' + id + '"><span class="fb-dot" style="background:' + colorDot(k) + '"></span>' + esc(o.name) +
              (o.p && isPreorder(o.p) ? '<em class="fb-pre">Pre-order</em>' : '') + '</label>';
          }).join('') + '</fieldset>';
      }
    }

    // Step: brightness / LEDs
    if (atHC.length > 1) {
      if (v2) {
        var names = atHC.length === 2 ? ['Bright', 'Brighter'] : ['Bright', 'Brighter', 'Brightest', 'Brightest+'];
        html += '<div class="fb-step"><div class="fb-label">Brightness</div><div class="fb-cards">' +
          atHC.map(function (p, i) {
            var pop = (p.tags || []).indexOf('fb-popular') > -1 ? '<em class="fb-badge">Most popular</em>' : '';
            return '<a class="fb-card' + (p.id === c.id ? ' is-on' : '') + '" data-dim="l" data-val="' + num(p.l) + '" href="#">' + pop + '<b>' + names[Math.min(i, names.length - 1)] + '</b><span>' + fmtLeds(p.l) + ' LEDs</span><strong>' + money(p.price, self.cur) + '</strong>' +
              (isPreorder(p) ? '<em class="fb-pre">Pre-order</em>' : '') + '</a>';
          }).join('') + '</div></div>';
      } else {
        html += '<fieldset class="fb-step product-form__input product-form__input--pill"><legend class="form__label">Brightness</legend>' +
          atHC.map(function (p, i) {
            var id = uid + 'l' + i;
            var pop = (p.tags || []).indexOf('fb-popular') > -1 ? '<small> · most popular</small>' : '';
            return '<input type="radio" id="' + id + '" name="' + uid + 'l" data-dim="l" data-val="' + num(p.l) + '"' + (p.id === c.id ? ' checked' : '') + '><label for="' + id + '">' + fmtLeds(p.l) + ' LEDs' + pop + '</label>';
          }).join('') + '</fieldset>';
      }
    }

    this.root.querySelector('[data-fb-picker-ui]').innerHTML = html;
    this.root.addEventListener('click', this.onClick.bind(this));
    this.root.addEventListener('change', this.onClick.bind(this));
  };

  Picker.prototype.onClick = function (e) {
    var el = e.target.closest('[data-dim]');
    if (!el || !this.root.contains(el)) return;
    e.preventDefault();
    var dim = el.dataset.dim, raw = el.dataset.val;
    var val = (dim === 'h' || dim === 'l') ? parseInt(raw, 10) : raw;
    var t = this.targetFor(dim, val);
    if (dim === 'mode' && (val === 'pole') === this.isPole(this.current)) return;
    if (!t || t.id === this.current.id) return;
    this.root.classList.add('is-loading');
    window.location.href = withView(t.url);
  };

  /* ---------- Flagpole add-on + live total + sticky bar ---------- */
  function Upsell(root) {
    this.root = root;
    this.form = document.getElementById(root.dataset.formId);
    this.btn = document.getElementById('ProductSubmitButton-' + root.dataset.sectionId);
    this.base = parseInt(root.dataset.basePrice, 10) || 0;
    this.cur = root.dataset.currency || 'USD';
    this.label = root.dataset.addLabel || 'Add to cart';
    var self = this;
    root.addEventListener('change', function () { self.update(); });
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        var pole = self.selected();
        if (!pole || self.adding) return;
        e.preventDefault(); e.stopImmediatePropagation();
        self.adding = true;
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(pole.variant, 10), quantity: 1 }] })
        }).catch(function () {}).finally(function () {
          // continue with the theme's own add-to-cart (adds the tree and opens the cart drawer)
          var pf = self.form.closest('product-form');
          if (pf && pf.onSubmitHandler) pf.onSubmitHandler(new Event('submit', { cancelable: true }));
          else self.form.submit();
          setTimeout(function () { self.adding = false; }, 500);
        });
      }, true);
    }
    this.update();
  }
  Upsell.prototype.selected = function () {
    var el = this.root.querySelector('input[data-pole-variant]:checked');
    if (!el || !el.dataset.poleVariant) return null;
    return { variant: el.dataset.poleVariant, price: parseInt(el.dataset.polePrice, 10) || 0 };
  };
  Upsell.prototype.total = function () { var s = this.selected(); return this.base + (s ? s.price : 0); };
  Upsell.prototype.update = function () {
    var t = money(this.total(), this.cur);
    if (this.btn && !this.btn.disabled) {
      var span = this.btn.querySelector('span');
      if (span) span.textContent = this.label + ' · ' + t;
    }
    this.root.querySelectorAll('[data-pole-option]').forEach(function (o) {
      var i = o.querySelector('input'); o.classList.toggle('is-on', !!(i && i.checked));
    });
    document.querySelectorAll('[data-fb-sticky-total]').forEach(function (n) { n.textContent = t; });
    var s = this.selected();
    document.querySelectorAll('[data-fb-sticky-set]').forEach(function (n) { n.textContent = s ? n.dataset.withPole : n.dataset.treeOnly; });
  };

  function Sticky(bar) {
    var btn = document.getElementById(bar.dataset.button);
    if (!btn) return;
    var io = new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('fb-sticky-on', show);
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(btn);
    bar.querySelector('[data-fb-sticky-add]').addEventListener('click', function () { btn.click(); });
  }

  function boot() {
    document.querySelectorAll('[data-fb-picker]').forEach(function (el) { if (!el.__fb) { el.__fb = 1; new Picker(el); } });
    document.querySelectorAll('[data-fb-upsell]').forEach(function (el) { if (!el.__fb) { el.__fb = 1; new Upsell(el); } });
    document.querySelectorAll('[data-fb-sticky]').forEach(function (el) { if (!el.__fb) { el.__fb = 1; new Sticky(el); } });
  }
  /* keep theme preview / alternate view on series links */
  function keepLinks() {
    var q = new URLSearchParams(location.search), keep = [];
    ['preview_theme_id', 'view'].forEach(function (k) { if (q.get(k)) keep.push([k, q.get(k)]); });
    if (!keep.length) return;
    document.querySelectorAll('a[data-fb-keep]').forEach(function (a) {
      try { var u = new URL(a.href, location.origin); keep.forEach(function (kv) { u.searchParams.set(kv[0], kv[1]); }); a.href = u.pathname + u.search; } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){boot();keepLinks();}); else { boot(); keepLinks(); }
})();
